import { gql, useQuery } from '@apollo/client';
import { useRouteMatch } from 'react-router-dom';

function useCategoryFiltersBySlug(colorIds, materialIds, patternIds, quickShip) {
  const match = useRouteMatch();
  const { loading, error, data } = useQuery(CATEGORY_FILTER_BY_SLUG, {
    variables: {
      slug: match.params.categorySlug,
      colorIds,
      materialIds,
      patternIds,
      quickShip
    }
  });
  return { loading, error, data };
}

export default useCategoryFiltersBySlug;

const CATEGORY_FILTER_BY_SLUG = gql`
  query categoryFiltersBySlug(
    $slug: String!
    $colorIds: [ID]
    $materialIds: [ID]
    $patternIds: [ID]
    $quickShip: Boolean
  ) {
    categoryFiltersBySlug(
      slug: $slug
      colorIds: $colorIds
      materialIds: $materialIds
      patternIds: $patternIds
      quickShip: $quickShip
    ) {
      colors {
        id
        name
        hex_code
      }
      patterns {
        id
        name
        total_fabrics
      }
      materials {
        id
        name
        total_fabrics
      }
      fabrics {
        id
        is_available_on_pdp
        slug
        name
        image
        collaborator {
          id
          name
        }
      }
    }
  }
`;
